<template>
  <div>
    <h1 class="border-b border-blackish text-sm">
      {{ $t('checkout.payment-method') }}
    </h1>
    <div>
      <ul class="mt-3">
        <li
          class="py-2 flex flex-col"
          v-for="paymentMethod in availablePaymentMethods"
          :key="paymentMethod.id"
        >
          <div class="flex">
            <input type="radio" :value="paymentMethod.slug" v-model="selectedMethod" :id="paymentMethod.slug" role="checkbox">
            <label :for="paymentMethod.slug" class="pl-1 text-xs w-full" :class="fontThin()">
              {{ paymentMethod.description }}
            </label>
            <div class="flex justify-end items-center w-full h-4" v-if="paymentMethod.slug === 'stripe'">
              <mastercard-logo aria-label="Mastercard"/>
              <amex-logo aria-label="American Express"/>
              <visa-logo aria-label="Visa" class="w-10 pl-2"/>
            </div>
            <div class="flex justify-end items-center w-48 h-5" v-if="paymentMethod.slug === 'paypal'">
              <paypal-logo-black aria-label="Paypal"/>
            </div>
            <div class="flex justify-end items-center w-48 h-5" v-if="paymentMethod.slug === 'sepa'">
              <img src="/sepa.png" alt="Sepa Direct Debit" class="w-12">
            </div>
            <div class="flex justify-end items-center w-48 h-5" v-if="paymentMethod.slug === 'sofort'">
              <sofort-logo />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import { getAvailablePayments } from '@/services/CartService';
import MastercardLogo from '../graphics/MastercardLogo.vue';
import AmexLogo from '../graphics/AmexLogo.vue';
import VisaLogo from '../graphics/VisaLogo.vue';
import PaypalLogoBlack from '../graphics/PaypalLogoBlack.vue';
import SofortLogo from '../graphics/SofortLogo.vue';

export default {
  components: {
    MastercardLogo, AmexLogo, VisaLogo, PaypalLogoBlack, SofortLogo,
  },
  props: ['value', 'showCash', 'shippingAddress'],

  data() {
    return {
      paymentMethods: [],
      selectedMethod: this.value.slug,
    };
  },

  created() {
    this.getPaymentMethods();
  },

  computed: {
    ...mapGetters({
      billingAddress: ['auth/billingAddress'],
      changedLocale: ['auth/changedLocale'],
      shop: ['shop'],
    }),

    trueShowCash() {
      if (!this.shippingAddress) {
        return this.showCash;
      }
      return this.showCash && this.shippingAddress.country === this.shop.country_code;
    },

    showSofort() {
      const availableCountries = ['AT', 'BE', 'DE', 'ES', 'IT', 'NL'];
      if (this.billingAddress && availableCountries.find((country) => country === this.billingAddress.country)) {
        return true;
      }
      if (!this.billingAddress) {
        return true;
      }
      return false;
    },

    availablePaymentMethods() {
      let availablePayments = this.paymentMethods;
      if (!this.showSofort) {
        availablePayments = this.paymentMethods.length > 0 ? this.paymentMethods.filter((method) => method.slug !== 'sofort') : this.paymentMethods;
      }
      if (!this.trueShowCash) {
        availablePayments = availablePayments.length > 0 ? availablePayments.filter((method) => method.slug !== 'cash') : availablePayments;
      }
      return availablePayments;
    },
  },

  watch: {
    changedLocale() {
      this.getPaymentMethods();
    },
    selectedMethod() {
      if (this.paymentMethods.length > 0) {
        this.$emit('input', this.paymentMethods.find((payment) => payment.slug === this.selectedMethod));
      }
    },
  },

  methods: {
    getPaymentMethods() {
      getAvailablePayments().then(({ data }) => {
        this.paymentMethods = [];
        this.paymentMethods = data;
        if (this.selectedMethod === undefined) {
          const firstMethod = this.paymentMethods[0];
          this.selectedMethod = firstMethod.slug;
        }
      });
    },
  },
};
</script>
